import { render } from "./newTodo.vue?vue&type=template&id=5f9b91a9"
import script from "./newTodo.vue?vue&type=script&lang=js"
export * from "./newTodo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__